import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import SRLKeyNumber from '../SRLKeyNumber/SRLKeyNumber';
import styles from './SRLAcademicContent.module.css';

function AveragesIntroList({ averages = [], isFullWidth }) {
  if (averages.length === 0) {
    return null;
  }

  const containerClasses = clsx({
    [styles.oneColumn]: isFullWidth,
  });

  return (
    <div className={containerClasses}>
      {averages.map(({ label, percent }, index) => (
        <SRLKeyNumber
          keyNumber={parseInt(+percent, 10)}
          postScript="%"
          label={label}
          key={index}
        />
      ))}
    </div>
  );
}

AveragesIntroList.propTypes = {
  isFullWidth: PropTypes.bool,
  averages: PropTypes.array.isRequired,
};

export default AveragesIntroList;
